import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { Params, Router, RouterModule } from '@angular/router';
import { MspButtonComponent } from 'src/app/page_component_item/msp-button/msp-button.component';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { CmdbPermissions } from 'src/app/util/interfaces/cmdbPermissions';
import { CmdbRegisterPageInfoService } from './data/cmdb-register-page-info.service';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { CmdbDigitalTerm } from 'src/app/util/interfaces/cmdbDigitalTerm';
import { firstValueFrom, Subscription } from 'rxjs';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { GenericFormGenService } from 'src/app/page_component_item/generic-form-gen/service/generic-form-gen.service';
import { LoadingNotificationService } from 'src/app/services/loading-notification/loading-notification.service';
import { CmdbPermissionsService } from '../../../cmdb-permissions/service/cmdb-permissions.service';
import { CmdbHomeScreenService } from '../../../cmdb-home-screen/service/cmdb-home-screen.service';
import { ShkDate } from 'shk-date';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserModalComponent } from 'src/app/page_component/user-modal/user-modal.component';
import { DateService } from 'src/app/services/date/date.service';

@Component({
	selector: 'cpi-cmdb-register-page-info',
	standalone: true,
	imports: [
		CommonModule,
		GenericFormGenModule,
		FaIconComponent,
		RouterModule,
		MspButtonComponent,
		DotBounceLoadingEffectModule,
		ModalComponent,
		InputWithAutocompleteModule,
		SvgGearsModule,
		FormsModule,
		UserModalComponent,
	],
	templateUrl: './cmdb-register-page-info.component.html',
	styleUrl: './cmdb-register-page-info.component.scss',
})
export class CmdbRegisterPageInfoComponent implements OnInit {
	private readonly labelsService = inject(LabelsService);
	private readonly cmdbRegisterPageInfoService = inject(CmdbRegisterPageInfoService);
	private readonly cmdbPermissionsService = inject(CmdbPermissionsService);
	private readonly cmdbHomeScreenService = inject(CmdbHomeScreenService);
	private readonly notificationService = inject(NotificationService);
	private readonly genericFormGenService = inject(GenericFormGenService);
	private readonly loadingNotificationService = inject(LoadingNotificationService);
	private readonly profileService = inject(ProfileService);
	private readonly router = inject(Router);
	public readonly dateService = inject(DateService);
	public readonly permissionService = inject(PermissionService);

	@ViewChild('digitalTermModal') digitalTermModal: ModalComponent;
	@ViewChild('confirmMassRegisterModal') confirmMassRegisterModal: ModalComponent;
	@ViewChild('infoUserModal') infoUserModal: ModalComponent;

	@Input() viewType: 'read' | 'edit';
	@Output() viewTypeChange = new EventEmitter<'read' | 'edit'>();

	@Input() selectedCi: ciInterface2;
	@Input() cameFromCmdbList = false;
	@Input() cmdbListQueryParams: Params = {};

	icons = {
		faAngleUp: faAngleUp,
		faAngleDown: faAngleDown,
	};
	labels: LabelsInterface;

	collapseForm = {
		CMDB: false,
		CI: false,
		CUSTOMFIELD: false,
		SOLUTIONAREA: true,
	};

	clonedId = '';
	registerQuantity = 1;
	originForm: genericFormI[] = [];
	showOriginForm = false;

	requiredPermissions: CmdbPermissions[] = [];

	isLoadingAvailableCiTypes = true;
	availableCiTypes: ciTypesInterface[];
	selectedCiType: ciTypesInterface;

	todayDate = new ShkDate();
	availableBaselineDates: string[];
	@Input() baselineDate = new ShkDate();
	@Output() baselineDateChange = new EventEmitter<ShkDate>();
	ciDataReq: Subscription;
	isLoadingCiBasicInformation = true;
	registerForm: genericFormI[] = [];
	registerFormMemory: genericFormI[] = [];
	fieldDictionary = {};
	typeField: genericFormI;
	ciList: ciInterface2[] = [];

	defaultFieldsLength = 0;
	ciFieldsLength = 0;
	customFieldsLength = 0;

	@Input() formColumns = 2;

	valueTapChanges = false;

	isUpdatingCi = false;
	isLoadingDynamicSubSelect = []; //É adicionado valores dentro do array dinamicamente a cada requisição, o carregamento está finalizado quando não há itens.
	isLoadingStorageLocations = false;
	private lastStorageLocality = '';
	isLoadingRegisterForm = true;
	@Input() lockViewType = false;

	isLoadingDigitalTerm = false;
	digitalTermReq: Subscription;
	cmdbDigitalTermFormNames = ['identification', 'enduser', 'status', 'location'];
	cmdbDigitalTermEditFormNames = ['enduser', 'status', 'location'];
	cmdbDigitalTermForm: genericFormI[] = [];
	cmdbDigitalTermPayload: CmdbDigitalTerm = {} as CmdbDigitalTerm;
	cmdbDigitalTermPayloadCopy: CmdbDigitalTerm | null = null;
	cmdbDigitalTermLogPayload: CmdbDigitalTerm;
	baselineToDigitalTermPayload: any = {} as any;
	isEditingTerm = false;
	ciTermLogReq: Subscription;
	isLoadingLogTerm = false;
	changeRouteWithChanges = false;

	modalIdEnduser: string;
	modalIdStockCmdb = '';
	isOpenModalStockCount = false;

	allowedUserCopy: any[] = [];
	allowedUserCopyIAC: iacOptionInterface[] = [];
	selectedUserCopyUser: any = { full_name: '', email: '', id: '' };
	isLoadingUserCopy = false;

	isUpdatingDigitalTerm = false;
	isUserNotified = false;

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}

	ngOnInit(): void {
		this.cmdbRegisterPageInfoService
			.getAvailableCiTypes()
			.subscribe({
				next: (availableCiTypes) => {
					this.availableCiTypes = availableCiTypes;
					const typeField: genericFormI = {
						id: 'type',
						label: 'lbl_geral_tipo',
						inputType: 'select',
						name: 'type',
						required: true,
						values: [''],
						rawValues: [],
						items: [],
						extraFunction: (idCiType: string) => {
							this.selectedCiType = this.availableCiTypes.find((ciTypes) => {
								if (ciTypes.id == idCiType) return ciTypes;
							});
							this.getEmptyRegisterForm(idCiType);
						},
					};
					for (const ciType of this.availableCiTypes) {
						const newItem = { label: ciType.label, name: ciType.type, values: [ciType.id] };
						typeField.items.push(newItem);
					}
					this.typeField = typeField;

					if (this.selectedCi.id != undefined && this.selectedCi.id != '') {
						this.cmdbRegisterPageInfoService
							.getBasicCiInformation(this.selectedCi.id)
							.subscribe({
								next: (ciListRes) => {
									this.ciList = ciListRes;
									if (
										!this.checkPermissionByType() &&
										!this.permissionService.hasPermission('cmdb_digital_term_logistic_operator')
									) {
										this.viewType = 'read';
										this.viewTypeChange.emit('read');
									}
								},
							})
							.add(() => {
								this.isLoadingCiBasicInformation = false;
							});
						this.getCiFormAndData(this.selectedCi.id);
						this.getAvailableCiBaselineDates(this.selectedCi.id);
					} else {
						this.cleanSelectedCi();
						this.registerForm.push(typeField);
						this.defaultFieldsLength = 1;
						this.isLoadingRegisterForm = false;
						this.isLoadingCiBasicInformation = false;
					}
				},
			})
			.add(() => {
				this.isLoadingAvailableCiTypes = false;
			});

		//Atribui o valor do campo "enduser" a variavel modalIdEnduser
		this.cmdbRegisterPageInfoService.divOpened.subscribe(() => {
			for (let index = 0; index < this.registerForm.length; index++) {
				const formItem = this.registerForm[index];
				if (formItem.name === 'enduser') {
					if (Number.parseInt(this.registerForm[index].values[0]) > 0) {
						this.modalIdEnduser = this.registerForm[index].values[0];
						this.infoUserModal.openModal();
					} else {
						this.notificationService.setNotificationMessage(this.labels.lbl_general_select_user);
					}
				}
			}
		});

		//Atribui o valor do campo "id" a variavel isOpenModalStockCount
		this.cmdbRegisterPageInfoService.divOpenedStock.subscribe(() => {
			for (let index = 0; index < this.registerForm.length; index++) {
				const formItem = this.registerForm[index];
				if (formItem.name === 'cmdb_id') {
					this.modalIdStockCmdb = this.registerForm[index].values[0];
					this.isOpenModalStockCount = true;
				}
			}
		});

		this.getSendEmailCopy();
	}

	getCiData(idCi: string): void {
		this.isLoadingRegisterForm = true;
		this.cmdbRegisterPageInfoService
			.getCiData(idCi, this.baselineDate)
			.subscribe({
				next: (ciData) => {
					const ciKeys = Object.keys(ciData);
					for (const ciKeysItem of ciKeys) {
						if (!this.fieldDictionary[ciKeysItem]) continue;

						const formItem = this.fieldDictionary[ciKeysItem];

						//Se o nome do item do ci é equivalente ao formulário necessário.
						if (ciKeysItem.toLocaleLowerCase().trim() === formItem.name.toLocaleLowerCase().trim()) {
							if (formItem.inputType === 'multi-select') {
								formItem.values = ciData[ciKeysItem];
								const temporaryItemHolder = [];
								for (const item of formItem.items) {
									if (formItem.values.includes(item.values[0])) {
										temporaryItemHolder.push(item);
									}
								}
								formItem.values = temporaryItemHolder;
							} else if (formItem.inputType === 'multi-input') {
								//Alguns casos o campo salva os multi inputs como um JSON.stringify
								//Alguns casos ele retorna o valor já parseado, essa é a validação.
								try {
									formItem.values = JSON.parse(ciData[ciKeysItem]);
								} catch {
									formItem.values = ciData[ciKeysItem];
								}
							} else if (Array.isArray(ciData[ciKeysItem])) {
								formItem.values = ciData[ciKeysItem];
							} else {
								formItem.values[0] = ciData[ciKeysItem];
							}
						}

						this.handleSubSelectLoad();
						this.formatFields();

						this.selectedCi = ciData;
						this.selectedCi.relationships = ciData.relationships;
						this.selectedCi.isLeaf = ciData.relationships.childs.length > 0;
						this.selectedCi.isRoot = ciData.relationships.parents.length > 0;
						this.cmdbRegisterPageInfoService.editonly = true;
						this.cmdbRegisterPageInfoService.ciType = this.selectedCi.type;
					}
				},
			})
			.add(() => {
				this.registerFormMemory = JSON.parse(JSON.stringify(this.registerForm));
				this.isLoadingRegisterForm = false;
			});
	}

	getCiFormAndData(idCi: string): void {
		if (this.ciDataReq) this.ciDataReq.unsubscribe();

		this.isLoadingRegisterForm = true;
		this.ciDataReq = this.cmdbRegisterPageInfoService.getCiData(idCi, this.baselineDate).subscribe({
			next: (ciData) => {
				this.cmdbRegisterPageInfoService
					.getRegisterForm(ciData.type, idCi)
					.subscribe({
						next: (registerForm) => {
							const hasPermissionToEditThisType = this.checkPermissionByType();

							//REGISTER FORM HANDLING
							this.registerForm = registerForm;
							for (const formItem of this.registerForm) {
								this.fieldDictionary[formItem.name] = formItem;

								if (
									!hasPermissionToEditThisType &&
									this.permissionService.hasPermission('cmdb_digital_term_logistic_operator') &&
									!this.cmdbDigitalTermEditFormNames.includes(formItem.name)
								) {
									formItem.disabled = true;
								}
							}

							if (idCi) {
								const ciKeys = Object.keys(ciData);
								for (const ciKeysItem of ciKeys) {
									if (!this.fieldDictionary[ciKeysItem]) continue;

									const formItem = this.fieldDictionary[ciKeysItem];

									//Se o nome do item do ci é equivalente ao formulário necessário.
									if (ciKeysItem.toLocaleLowerCase().trim() === formItem.name.toLocaleLowerCase().trim()) {
										if (formItem.inputType === 'multi-select') {
											formItem.values = ciData[ciKeysItem];
											const temporaryItemHolder = [];
											for (const item of formItem.items) {
												if (formItem.values.includes(item.values[0])) {
													temporaryItemHolder.push(item);
												}
											}
											formItem.values = temporaryItemHolder;
										} else if (formItem.inputType === 'multi-input') {
											//Alguns casos o campo salva os multi inputs como um JSON.stringify
											//Alguns casos ele retorna o valor já parseado, essa é a validação.
											try {
												formItem.values = JSON.parse(ciData[ciKeysItem]);
											} catch {
												formItem.values = ciData[ciKeysItem];
											}
										} else if (Array.isArray(ciData[ciKeysItem])) {
											formItem.values = ciData[ciKeysItem];
										} else {
											formItem.values[0] = ciData[ciKeysItem];
										}
									}
								}
							}

							this.formatFields();
							this.handleSubSelectLoad();
							this.loadStorageLocationsForSelectedLocality();

							this.defaultFieldsLength = this.cmdbRegisterPageInfoService.defaultFieldsLength;
							this.ciFieldsLength = this.cmdbRegisterPageInfoService.ciFieldsLength;
							this.customFieldsLength = this.cmdbRegisterPageInfoService.customFieldsLength;
							//END OF REGISTER FORM HANDLING

							//CI DATA HANDLING
							if (!idCi) return;

							if (ciData.id_customer.toString() != this.profileService.userData().idCustomer.toString()) {
								this.notificationService.setNotificationMessage(this.labels.lbl_rep_custom_arquivo_nao_encontrado);
								this.router.navigate(['/cmdb/list']);
								return;
							}

							if (ciData.status) {
								const statusField = this.registerForm.find((field) => field.name === 'status');
								const deletedStatus = statusField.items.find(
									(item) => item.values[0] === 'Deleted' || item.other_names?.includes('Deleted')
								);
								deletedStatus.disabled = true;
							}

							this.selectedCi = ciData;
							this.selectedCi.relationships = ciData.relationships;
							this.selectedCi.isLeaf = ciData.relationships.childs.length > 0;
							this.selectedCi.isRoot = ciData.relationships.parents.length > 0;
							this.cmdbRegisterPageInfoService.editonly = true;
							this.cmdbRegisterPageInfoService.ciType = this.selectedCi.type;
							//END OF CI DATA HANDLING
						},
					})
					.add(() => {
						this.registerFormMemory = JSON.parse(JSON.stringify(this.registerForm));
						this.isLoadingRegisterForm = false;

						this.cmdbHomeScreenService.getCmdbDigitalTerm(this.selectedCi.id).subscribe({
							next: (payload: CmdbDigitalTerm) => {
								if (payload.status !== 204) {
									payload.statusCmdb = this.selectedCi.status || '';
									payload.user = this.getSelectedItemName('enduser');
									this.cmdbDigitalTermPayloadCopy = payload;
								}
							},
							complete: () => {
								this.isLoadingDigitalTerm = false;
							},
							error: (error) => {
								console.error('Erro ao carregar termo:', error);
							},
						});
					});
			},
		});
	}

	getAvailableCiBaselineDates(idCi: string): void {
		this.cmdbRegisterPageInfoService.getAvailableCiBaselineDates(idCi).subscribe({
			next: (availableDates) => {
				this.availableBaselineDates = availableDates;
			},
		});
	}

	cleanSelectedCi(): void {
		this.selectedCi = {
			id: '',
			type: '',
			identification: '',
			last_audit: undefined,
			active: true,
			location: '',
			id_location: '',
			notes: '',
			status: '',
			monthly_depreciation: undefined,
			ready_to_audit: 0,
			cc_customer: '',
			id_customer: '',
			project: '',
			price: 0,
			invoice_number: '',
			enduser: '',
			id_enduser: '',
			warranty_type: '',
			impact: '',
			id_impact: '',
			next_audit: undefined,
			id_department: '',
			department: '',
			purchase_order: '',
			depreciation_limit: undefined,
			physical_location: '',
			purchase_date: undefined,
			warranty_limit: undefined,
			relationships: undefined,
			cost_center: '',
			deactivation_date: '',
			label_type: '',
		};
	}

	getEmptyRegisterForm(idCiType: string): void {
		this.isLoadingRegisterForm = true;
		this.cmdbRegisterPageInfoService
			.getRegisterForm(idCiType)
			.subscribe({
				next: (registerForm) => {
					//REGISTER FORM HANDLING
					this.registerForm = registerForm.map((field) => ({
						...field,
						alert: field.alert ?? false,
						hidden: field.name === 'storage_location' ? true : field.hidden,
						required: field.name === 'storage_location' ? false : field.required,
						values: field.name === 'storage_location' ? [''] : field.values,
						items: field.name === 'storage_location' ? [] : field.items,
					}));
					for (const formItem of this.registerForm) {
						this.fieldDictionary[formItem.name] = formItem;
					}

					this.handleSubSelectLoad();
					this.formatFields();
					this.loadStorageLocationsForSelectedLocality();

					this.defaultFieldsLength = this.cmdbRegisterPageInfoService.defaultFieldsLength;
					this.ciFieldsLength = this.cmdbRegisterPageInfoService.ciFieldsLength;
					this.customFieldsLength = this.cmdbRegisterPageInfoService.customFieldsLength;
					//END OF REGISTER FORM HANDLING
				},
			})
			.add(() => {
				this.isLoadingRegisterForm = false;
			});
	}

	setSelectedCi(): void {
		for (let index = 0; index < this.registerForm.length; index++) {
			const formItem = this.registerForm[index];
			if (!Object.keys(this.selectedCi).includes(formItem.name) || formItem.values[0] == undefined) continue;

			this.selectedCi[formItem.name] =
				formItem.inputType == 'multi-input' || formItem.inputType == 'multi-select' || formItem.inputType == 'checkbox'
					? formItem.values
					: formItem.values[0];
		}
		this.loadStorageLocationsForSelectedLocality();
	}

	loadStorageLocationsForSelectedLocality(): void {
		const localityField = this.registerForm.find((field) => field.name === 'location');
		const storageField = this.registerForm.find((field) => field.name === 'storage_location');
		if (!storageField) return;

		const localityId = localityField?.values?.[0] ? localityField.values[0].toString() : '';
		if (localityId === this.lastStorageLocality && !this.isLoadingStorageLocations) return;
		const savedStorageLocationId = storageField.values?.[0]?.toString() || '';
		this.lastStorageLocality = localityId;
		storageField.values = [''];
		storageField.items = [];
		storageField.required = false;
		storageField.hidden = true;
		if (!localityId || localityId === '0' || localityId === '-1') return;

		this.isLoadingStorageLocations = true;
		this.cmdbRegisterPageInfoService
			.getLocality(localityId)
			.subscribe({
				next: (locality) => {
					if (Number(locality?.is_stock) !== 1) return;
					this.cmdbRegisterPageInfoService.getStorageLocationOptions(localityId).subscribe({
						next: (options) => {
							storageField.items = options.map((option) => ({ label: option.name, name: option.name, values: [option.id] }));
							const savedOption = options.find((option) => option.id.toString() === savedStorageLocationId);
							if (savedOption) {
								storageField.values = [savedOption.id];
							}
							storageField.hidden = options.length === 0;
							storageField.required = options.length > 0;
						},
					});
				},
				error: () => {
					storageField.hidden = true;
				},
			})
			.add(() => {
				this.isLoadingStorageLocations = false;
			});
	}

	showDigitalTerm(): boolean {
		if (!this.permissionService.hasPermission('cmdb_digital_term')) return false;

		const ciType = this.availableCiTypes.find((type) => type.id === this.selectedCi.type);
		return ciType?.digitalTerm ?? false;
	}

	checkPermissionByType(): boolean {
		let permissionResults: boolean[] = [];
		let hasPermission = false;

		this.cmdbPermissionsService.getCmdbPermissions().subscribe((data) => {
			this.requiredPermissions = data;
		});

		permissionResults = this.ciList.map((item, index) => {
			hasPermission = this.requiredPermissions.some(
				(permission) => permission.label === item.label_type && this.permissionService.hasPermission(permission.permission)
			);

			if (!hasPermission && this.ciList.length > 1) {
				this.ciList.splice(index, 1);
			}

			return hasPermission;
		});

		hasPermission = permissionResults.every((result) => result === true);
		return hasPermission;
	}

	disableDigitalTermEditing(): boolean {
		if (this.viewType === 'edit') return true;

		const allowedStatus = ['Em Estoque', 'Em Uso'];
		const isStatusAllowed = allowedStatus.includes(this.selectedCi.status);

		return !isStatusAllowed;
	}

	openDigitalTermModal(idCMDB: string): void {
		if (!this.checkPermissionByType() && !this.permissionService.hasPermission('cmdb_digital_term_logistic_operator')) return;

		this.setDigitalTermFieldsForm();

		this.digitalTermModal.openModal();
		this.loadBaselineToDigitalTerm(idCMDB, () => this.loadCmdbDigitalTerm(idCMDB));
	}

	setDigitalTermFieldsForm(): void {
		const digitalTermForm = [];

		const identificationFormItem = this.registerForm.find((formItem) => {
			return formItem.name == 'identification';
		});
		if (identificationFormItem) {
			identificationFormItem.disabled = true;
			digitalTermForm.push(identificationFormItem);
		}

		const enduserFormItem = this.registerForm.find((formItem) => {
			return formItem.name == 'enduser';
		});
		if (enduserFormItem) {
			digitalTermForm.push(enduserFormItem);
		}

		const statusFormItem = this.registerForm.find((formItem) => {
			return formItem.name == 'status';
		});
		if (statusFormItem) {
			digitalTermForm.push(statusFormItem);
		}

		const locationFormItem = this.registerForm.find((formItem) => {
			return formItem.name == 'location';
		});
		if (locationFormItem) {
			digitalTermForm.push(locationFormItem);
		}
		// for(let i = 0; i < this.registerForm.length; i++) {
		//   let formItem = this.registerForm[i]
		//   if(!this.cmdbDigitalTermFormNames.includes(formItem.name)) continue;

		//   this.cmdbDigitalTermForm.push(formItem);
		// }

		this.cmdbDigitalTermForm = digitalTermForm;
		// this.cmdbDigitalTermForm = JSON.parse(JSON.stringify(digitalTermForm));
	}

	getSelectedItemName(fieldName: string): string | undefined {
		const field = this.fieldDictionary[fieldName];

		if ((fieldName == 'enduser' || fieldName == 'location') && field && field.items) {
			let selectedValue = '';
			fieldName === 'enduser' ? (selectedValue = this.selectedCi?.enduser) : (selectedValue = this.selectedCi?.location);
			const selectedItem = field.items.find((item: any) => item.values.includes(selectedValue));
			return selectedItem ? selectedItem.name : undefined;
		}
		return undefined;
	}

	loadBaselineToDigitalTerm(idCMDB: string, callback?: () => void): void {
		this.cmdbRegisterPageInfoService.readBaseline(idCMDB).subscribe((data) => {
			this.baselineToDigitalTermPayload = data;
			if (callback) {
				callback();
			}
		});
	}

	loadCmdbDigitalTerm(idCMDB: string): void {
		this.isLoadingDigitalTerm = true;
		if (this.digitalTermReq) this.digitalTermReq.unsubscribe();

		this.digitalTermReq = this.cmdbHomeScreenService.getCmdbDigitalTerm(idCMDB).subscribe({
			next: (payload: CmdbDigitalTerm) => {
				if (payload.status === 204) {
					this.cmdbDigitalTermPayload = {
						id: '',
						cmdb_id: idCMDB,
						attachment: '',
						checklist: -1,
						customer: null,
						generate_send: 0,
						generation_date: '',
						return_or_exchange_equipment: -1,
						serial_number: this.selectedCi?.identification || '',
						signature: '',
						term_type: '',
						third_party_user: -1,

						oldStatus: this.selectedCi?.status || '',
						statusCmdb: this.baselineToDigitalTermPayload?.status || '',
						location: this.selectedCi?.location || '',
						idLocation: this.selectedCi?.id_location || '',
						user: '',
						idUser: this.baselineToDigitalTermPayload?.id_enduser || '',
						oldUser: '',
						idOldUser: '',

						user_disconnected: -1,
						uuid: '',
						user_substitute: '',
						identification: '',
					};

					this.cmdbDigitalTermPayloadCopy = this.cmdbDigitalTermPayload;
				} else {
					payload.statusCmdb = this.selectedCi?.status || '';
					payload.idLocation = this.selectedCi?.id_location || '';
					payload.idUser = this.selectedCi?.enduser || '';
					payload.identification = this.baselineToDigitalTermPayload.identification || '';

					this.cmdbDigitalTermPayloadCopy = payload;
					this.cmdbDigitalTermPayload = { ...payload };
					if (this.isEditingTerm) {
						this.cmdbDigitalTermPayload.third_party_user = -1;
						this.cmdbDigitalTermPayload.return_or_exchange_equipment = -1;
						this.cmdbDigitalTermPayload.checklist = -1;
						this.cmdbDigitalTermPayload.user_disconnected = -1;
					}
				}
			},
		});

		this.digitalTermReq.add(() => {
			this.isLoadingDigitalTerm = false;
		});
	}

	setRegisterQuantity(quantityEvent: Event): void {
		const quantity = +(quantityEvent.target as HTMLInputElement).value;
		if (quantity < 1) {
			this.registerQuantity = 1;
		} else if (quantity > 20) {
			this.registerQuantity = 20;
		} else {
			this.registerQuantity = quantity;
		}
	}

	cancelClone(): void {
		this.selectedCi.id = '' + this.clonedId;
		this.clonedId = '';
		window.history.replaceState({}, null, `cmdb/${this.selectedCi.id}/edit`);
	}

	cloneCi(): void {
		this.ciList = [];
		this.clonedId = '' + this.selectedCi.id;
		this.selectedCi.id = '';
		window.history.replaceState({}, null, 'cmdb/new');
	}

	areRequiredFieldsFulfilled(): boolean {
		let areRequiredFieldsFulfilled = true;

		const cmdbStartI = 0;
		const cmdbFinishI = this.defaultFieldsLength - 1;
		const ciStartI = this.defaultFieldsLength;
		const ciFinishI = this.defaultFieldsLength + this.ciFieldsLength - 1;
		const customfieldStartI = this.defaultFieldsLength + this.ciFieldsLength;
		const customfieldFinishI = this.defaultFieldsLength + this.ciFieldsLength + this.customFieldsLength - 1;
		const solutionAreaStartI = this.defaultFieldsLength + this.ciFieldsLength + this.customFieldsLength;
		const solutionAreaFinishI = this.registerForm.length - 1;

		for (let index = 0; index < this.registerForm.length; index++) {
			const formItem = this.registerForm[index];
			// || formItem.inputType == 'multi-select'
			if (
				//Se o campo tiver um valor que seja um item, vamos validar se o valor salvo em baseline é um valor válido ou ele está depreciado em banco.
				(formItem.inputType == 'select' ||
					formItem.inputType == 'select-iac' ||
					formItem.inputType == 'radio' ||
					formItem.inputType == 'checkbox') &&
				formItem.required == true &&
				formItem.items.length > 0
			) {
				for (let valueI = 0; valueI < formItem.values.length; valueI++) {
					const fixedValue = formItem.values[valueI];
					const validItem = formItem.items.find((item: genericFormI<'item'>) => {
						return item.values[0].toString() == fixedValue.toString() && item.disabled != true;
					});

					if (validItem == undefined) {
						const valueIndex = formItem.values.indexOf(fixedValue);
						if (formItem.inputType == 'select') {
							formItem.values[valueIndex] = '-1';
							formItem.rawValues[valueIndex] = '-1';
						} else {
							formItem.values[valueIndex] = '0';
							formItem.rawValues[valueIndex] = '0';
						}
					}
				}
			}

			if (
				(formItem.required === true &&
					!formItem.hidden &&
					(formItem.values[0] === undefined ||
						formItem.values[0] === '' ||
						((formItem.inputType === 'boolean' || formItem.inputType === 'select') &&
							(formItem.values[0] === -1 || formItem.values[0] === '-1')))) ||
				(formItem.inputType === 'date' && formItem.values[0] && formItem.values[0].split('-')[0].length != 4)
				// || (formItem.inputType === 'multi-input')
			) {
				areRequiredFieldsFulfilled = false;
				formItem.alert = true;

				if (index >= cmdbStartI && index <= cmdbFinishI) this.collapseForm.CMDB = false;
				if (index >= ciStartI && index <= ciFinishI) this.collapseForm.CI = false;
				if (index >= customfieldStartI && index <= customfieldFinishI) this.collapseForm.CUSTOMFIELD = false;
				if (index >= solutionAreaStartI && index <= solutionAreaFinishI) this.collapseForm.SOLUTIONAREA = false;
			}
		}

		return areRequiredFieldsFulfilled;
	}

	handleSubSelectLoad(): void {
		const fieldDictionaryKeys = [];
		for (const formItem of this.registerForm) {
			fieldDictionaryKeys.push(formItem.name);
		}

		for (let index = 0; index < this.registerForm.length; index++) {
			const formItem = this.registerForm[index];
			if (!formItem.subSelect || formItem.subSelect.length === 0) continue;

			for (let index = 0; index < formItem.subSelect.length; index++) {
				const subSelectItem = formItem.subSelect[index];

				const subSelectChildName = subSelectItem.subSelectChildName;
				const subSelectQryName = subSelectItem.subSelectQryName;
				const when_value_is = subSelectItem.when_value_is;
				const make_required = subSelectItem.make_required;
				const parameters = [];
				for (const parameter of subSelectItem.parameters) {
					let keyName = '';
					const temporaryParameter = (<any>parameter).replaceAll('%', '.*');
					const regex = new RegExp(`^${temporaryParameter}$`);
					for (const key of fieldDictionaryKeys) {
						if (regex.test(key)) keyName = key;
					}

					if (keyName != '') {
						const field = this.registerForm.find((item) => {
							return item.name == keyName;
						});
						const keyValue = field.values[0];
						const newParameter = { key: keyName, value: keyValue };
						parameters.push(newParameter);
					}
				}

				if (when_value_is != undefined && when_value_is.length > 0 && !when_value_is.includes(formItem.values[0])) continue;

				if (
					subSelectChildName &&
					subSelectChildName != '' &&
					formItem.values[0] &&
					(formItem.values[0] != '' || formItem.values[0] != '-1')
				) {
					this.isLoadingDynamicSubSelect.push('§');
					this.genericFormGenService
						.getSubSelect(subSelectQryName, formItem.values[0], parameters)
						.subscribe({
							next: (subSelectItems) => {
								const formChildItem = this.registerForm.find((item) => {
									return item.name == subSelectChildName;
								});
								const formChildItemMemory = this.registerFormMemory.find((item) => {
									return item.name == subSelectChildName;
								});
								if (formChildItem != undefined) {
									formChildItem.items = subSelectItems;
									// formChildItem.values = formChildItemMemory?.values ? JSON.parse(JSON.stringify(formChildItemMemory.values)) : [];
									// formChildItem.rawValues = formChildItemMemory?.rawValues ? JSON.parse(JSON.stringify(formChildItemMemory.rawValues)) : [];

									// if(formChildItem.values.length > 0)
									if (make_required != undefined && make_required == true) formChildItem.required = true;
									if (make_required != undefined && make_required == false) formChildItem.required = false;
									formChildItem.hidden = false;
								}
							},
						})
						.add(() => {
							this.isLoadingDynamicSubSelect.pop();
						});
				}
			}
		}
	}

	formatFields(): void {
		for (const formItem of this.registerForm) {
			if (formItem.inputType === 'date' && formItem.values[0] && formItem.values[0] != '') {
				formItem.values[0] = this.cmdbRegisterPageInfoService.formatDateToService(new Date(formItem.values[0]));
			}
			if (formItem.name === 'type' && this.typeField != undefined) {
				formItem.required = true;
				formItem.items = this.typeField.items;
			}

			if (formItem.inputType === 'checkbox' || formItem.inputType === 'boolean' || formItem.inputType === 'bit') {
				if (formItem.values[0] && (formItem.values[0] == true || formItem.values[0].toString().toLowerCase() == 'true')) {
					formItem.values[0] = 1;
				}
				if (formItem.values[0] && (formItem.values[0] == false || formItem.values[0].toString().toLowerCase() == 'false')) {
					formItem.values[0] = 0;
				}
			}

			if (formItem.inputType === 'multi-input') {
				if (Array.isArray(formItem.values)) {
					for (const [index, value] of formItem.values.entries()) {
						formItem.values[index] = value.toString().split('§');
					}
					formItem.outItems = formItem.values;
				} else {
					formItem.values = [];
					formItem.outItems = [];
				}
			}

			if (
				formItem.name === 'cmdb_id' &&
				this.selectedCi &&
				this.selectedCi.id != undefined &&
				this.selectedCi.id.toString().trim() == ''
			) {
				formItem.values[0] = 0;
				formItem.required = false;
			}

			if (formItem.name === 'status') {
				formItem.extraFunction = () => {
					const type = this.registerForm.find((item) => {
						return item.name == 'type';
					}).values[0];
					this.cmdbRegisterPageInfoService.getManageFieldStateByStatus(formItem.values[0], type).subscribe((res) => {
						const active = this.registerForm.find((item) => {
							return item.name === 'active';
						});
						active.values[0] = res[0].status_active;
					});
				};
			}

			if (this.selectedCi && (this.selectedCi.type == '3' || this.selectedCi.type == '4') && formItem.name === 'version') {
				let version = '';

				switch (formItem.values[0]) {
					case 'Automatos': {
						version = formItem.values[0];
						break;
					}
					case 'AD': {
						version = formItem.values[0];
						break;
					}
					case 'Manual': {
						version = this.labels.lbl_geral_cadastro_manual;
						break;
					}
					default: {
						version = this.labels.lbl_geral_origem_nao_encontrada;
						break;
					}
				}

				const originForm: genericFormI = {
					disabled: true,
					label: 'lbl_geral_versao',
					name: 'origin',
					values: [version],
					items: [],
					rawValues: [],
					inputType: 'string',
					id: '',
				};

				this.originForm.push(originForm);
				this.showOriginForm = true;
			}

			if (formItem.name && formItem.name === 'active') {
				formItem.disabled = true;
			}
		}
	}

	reloadForm(ciData) {
		for (const cmdbKey of Object.keys(ciData.cmdb)) {
			const formField = this.registerForm.find((field) => {
				if (field.name == cmdbKey) return field;
			});
			if (formField != undefined) {
				if (formField.inputType === 'multi-select') {
					formField.values = ciData.cmdb[cmdbKey];
					const temporaryItemHolder = [];
					for (const item of formField.items) {
						if (formField.values.includes(item.values[0])) {
							temporaryItemHolder.push(item);
						}
					}
					formField.values = temporaryItemHolder;
				} else if (formField.inputType === 'multi-input') {
					try {
						formField.values = JSON.parse(ciData.cmdb[cmdbKey]);
					} catch {
						formField.values = ciData.cmdb[cmdbKey];
					}
				} else if (Array.isArray(ciData.cmdb[cmdbKey])) {
					formField.values = <any>ciData.cmdb[cmdbKey];
				} else {
					formField.values[0] = ciData.cmdb[cmdbKey];
				}
			}
		}

		for (const ciKey of Object.keys(ciData.ci)) {
			const formField = this.registerForm.find((field) => {
				if (field.name == ciKey) return field;
			});

			if (formField != undefined) {
				if (formField.inputType === 'multi-select') {
					formField.values = ciData.ci[ciKey];
					const temporaryItemHolder = [];
					for (const item of formField.items) {
						if (formField.values.includes(item.values[0])) {
							temporaryItemHolder.push(item);
						}
					}
					formField.values = temporaryItemHolder;
				} else if (formField.inputType === 'multi-input') {
					try {
						formField.values = JSON.parse(ciData.ci[ciKey]);
					} catch {
						formField.values = ciData.ci[ciKey];
					}
				} else if (Array.isArray(ciData.ci[ciKey])) {
					formField.values = <any>ciData.ci[ciKey];
				} else {
					formField.values[0] = ciData.ci[ciKey];
				}
			}
		}

		this.handleSubSelectLoad();
		this.formatFields();
	}

	setMemoryFromFields(): void {
		for (const field of this.registerForm) {
			const fieldMemory = this.registerFormMemory.find((fieldMemory) => {
				if (field.name == fieldMemory.name) return fieldMemory;
			});
			if (!fieldMemory) continue;
			fieldMemory.values = JSON.parse(JSON.stringify(field.values));
			fieldMemory.rawValues = JSON.parse(JSON.stringify(field.rawValues));
		}
	}

	registerCi(keepRegistering: boolean): void {
		if (this.isUpdatingCi) return;

		if (this.areRequiredFieldsFulfilled()) {
			this.isUpdatingCi = true;

			this.cmdbRegisterPageInfoService
				.createCiWithGeneric(this.registerForm, 1, '')
				.subscribe({
					next: (cmdbRes) => {
						this.notificationService.setNotificationMessage(`${this.labels.lbl_geral_criado_com_sucesso} (${cmdbRes.cmdb.id})`);
						if (keepRegistering == true) return;

						window.history.replaceState({}, null, '/cmdb/' + cmdbRes.ci.cmdb_id + '/read');

						if (this.clonedId != '') {
							this.reloadForm(cmdbRes);
						}
						this.selectedCi = this.cmdbRegisterPageInfoService.formatCmdbResToInterface(cmdbRes, { childs: [], parents: [] });
						this.selectedCi.relationships = { childs: [], parents: [] };
						this.selectedCi.isLeaf = false;
						this.selectedCi.isRoot = false;
						this.cmdbRegisterPageInfoService.editonly = true;
						this.cmdbRegisterPageInfoService.ciType = this.selectedCi.type;
						this.clonedId = '';

						this.viewType = 'read';
						this.viewTypeChange.emit('read');
						this.setMemoryFromFields();
					},
					error: (error) => {
						if (error?.error?.ExtendedInfo) {
							const pError = JSON.parse(error.error.ExtendedInfo);

							if (pError && pError.label) this.notificationService.setNotificationMessage(pError.label);
							else this.notificationService.setNotificationMessage(this.labels.lbl_erro_0113);

							return;
						}
					},
				})
				.add(() => {
					if (this.registerQuantity > 1) this.registerQuantity--;
					else {
						this.cmdbRegisterPageInfoService
							.openModalViewDigitalTerm({
								status: this.selectedCi?.status,
								idCMDB: this.selectedCi?.id,
								idUser: this.selectedCi?.enduser,
							})
							.subscribe({
								next: (openTermModal) => {
									if (openTermModal == true) this.openDigitalTermModal(this.selectedCi.id);
								},
							});
					}
					this.isUpdatingCi = false;
				});
		} else {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_campos_marcados);
		}
	}

	massRegisterCi(): void {
		if (this.isUpdatingCi) return;

		if (this.areRequiredFieldsFulfilled()) {
			this.isUpdatingCi = true;
			const idNotificaton = this.loadingNotificationService.setNotificationMessage(
				`${this.registerQuantity}x ${this.selectedCi.identification}`,
				'loading',
				'faDatabase'
			);

			this.cmdbRegisterPageInfoService
				.createCiWithGeneric(this.registerForm, this.registerQuantity, '')
				.subscribe({
					next: (cmdbRes) => {
						this.loadingNotificationService.updateNotificationStatus(idNotificaton, 'success');
						this.notificationService.setNotificationMessage(this.labels.lbl_carga_executada_sucesso);
					},
					error: (error) => {
						if (error?.error?.ExtendedInfo) {
							const pError = JSON.parse(error.error.ExtendedInfo);

							if (pError && pError.label) this.notificationService.setNotificationMessage(pError.label);
							else this.notificationService.setNotificationMessage(this.labels.lbl_erro_0113);

							return;
						}
					},
				})
				.add(() => {
					if (this.registerQuantity > 1) this.registerQuantity = 1;
					this.viewType = 'read';
					this.viewTypeChange.emit('read');
					this.isUpdatingCi = false;
				});
		} else {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_campos_marcados);
		}
	}

	getDigitalTermLogs(idCMDB: string): void {
		if (this.ciTermLogReq) this.ciTermLogReq.unsubscribe();

		this.isLoadingLogTerm = true;
		this.ciTermLogReq = this.cmdbHomeScreenService.getCmdbDigitalTerm(idCMDB).subscribe((data) => {
			this.cmdbDigitalTermLogPayload = data;
		});
		this.ciTermLogReq.add(() => {
			this.isLoadingLogTerm = false;
		});
	}

	updateCi(): void {
		if (this.isUpdatingCi) return;

		if (this.areRequiredFieldsFulfilled()) {
			this.isUpdatingCi = true;
			this.cmdbRegisterPageInfoService
				.updateCiWithGeneric(this.registerForm, this.selectedCi.id, '')
				.subscribe({
					next: (ciDataRes) => {
						this.notificationService.setNotificationMessage(this.labels.lbl_successful_updated);
						this.selectedCi.active = true;
						this.reloadForm(ciDataRes);
						this.setMemoryFromFields();
						this.getDigitalTermLogs(this.selectedCi.id);
						this.viewType = 'read';
						this.viewTypeChange.emit('read');
					},
					error: (error) => {
						if (error?.error?.ExtendedInfo) {
							const pError = JSON.parse(error.error.ExtendedInfo);

							if (pError && pError.label) this.notificationService.setNotificationMessage(pError.label);
							else this.notificationService.setNotificationMessage(this.labels.lbl_erro_0113);

							return;
						}
					},
				})
				.add(() => {
					this.isUpdatingCi = false;
					this.valueTapChanges = false;
					this.changeRouteWithChanges = false;

					setTimeout(async () => {
						try {
							const isAllowed = await firstValueFrom(
								this.cmdbRegisterPageInfoService.openModalViewDigitalTerm({
									status: this.selectedCi?.status,
									idCMDB: this.selectedCi?.id,
									idUser: this.selectedCi?.enduser,
								})
							);
							if (isAllowed) {
								this.openDigitalTermModal(this.selectedCi.id);
							}
						} catch (error) {
							console.error('Error while checking custom status:', error);
						}
					}, 3000);
				});
		} else {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_campos_marcados);
		}
	}

	setFieldsFromMemory(): void {
		for (const fieldMemory of this.registerFormMemory) {
			const field = this.registerForm.find((field) => {
				if (field.name == fieldMemory.name) return field;
			});
			field.alert = false;
			field.values = JSON.parse(JSON.stringify(fieldMemory.values));
			field.rawValues = JSON.parse(JSON.stringify(fieldMemory.rawValues));
		}
		this.handleSubSelectLoad();
	}

	setFieldsFromBaseline(inputEvent: Event): void {
		const target = inputEvent.target as HTMLInputElement;
		this.baselineDate = new ShkDate(target.value);
		this.baselineDateChange.emit(this.baselineDate);
		this.getCiData(this.selectedCi.id);
	}

	toggleEditMode(): void {
		this.isEditingTerm = !this.isEditingTerm;
		this.isEditingTerm ? this.setDigitalTermFieldsDefault() : this.restoreDigitalTermFields();
	}

	setDigitalTermFieldsDefault(): void {
		this.cmdbDigitalTermPayload = {
			...this.cmdbDigitalTermPayload,
			checklist: -1,
			return_or_exchange_equipment: -1,
			user_disconnected: -1,
			third_party_user: -1,
		};
	}

	restoreDigitalTermFields(): void {
		this.cmdbDigitalTermPayload = {
			...this.cmdbDigitalTermPayload,
			checklist: this.cmdbDigitalTermPayloadCopy?.checklist ?? -1,
			return_or_exchange_equipment: this.cmdbDigitalTermPayloadCopy?.return_or_exchange_equipment ?? -1,
			user_disconnected: this.cmdbDigitalTermPayloadCopy?.user_disconnected ?? -1,
			third_party_user: this.cmdbDigitalTermPayloadCopy?.third_party_user ?? -1,
		};
	}

	validateDigitalTermForm(): boolean {
		return (
			this.cmdbDigitalTermPayload.checklist === -1 ||
			this.cmdbDigitalTermPayload.return_or_exchange_equipment === -1 ||
			this.cmdbDigitalTermPayload.user_disconnected === -1 ||
			this.cmdbDigitalTermPayload.third_party_user === -1
		);
	}

	saveCmdbDigitalTerm(): void {
		if (this.isUpdatingDigitalTerm) return;
		// Validação de confirmação quando houver responsável substituto selecionado
		if (
			this.cmdbDigitalTermPayload &&
			this.cmdbDigitalTermPayload.user_substitute &&
			this.cmdbDigitalTermPayload.user_substitute !== '' &&
			!this.isUserNotified
		) {
			let selectedUser: any = null;

			if (this.allowedUserCopy && this.allowedUserCopy.length > 0) {
				selectedUser = this.allowedUserCopy.find((user: any) => user.value === this.cmdbDigitalTermPayload.user_substitute);
			}

			if (selectedUser) {
				const userName = selectedUser.name || selectedUser.full_name || '';
				const userEmail = selectedUser.email || '';

				const message =
					`${this.labels.lbl_geral_substituto_responsavel}: ${userName} (${userEmail}).` +
					`\nDeseja realmente enviar o termo para este responsável substituto?`;

				this.notificationService.setNotificationMessage(message);
				this.isUserNotified = true;
				return;
			}
		}

		this.isUpdatingDigitalTerm = true;

		this.cmdbDigitalTermPayload.customerUrl = new URL(window.location.href).origin;

		if (this.cmdbDigitalTermPayload?.id) {
			const termId = this.cmdbDigitalTermPayload.id.toString();

			if (this.validateDigitalTermForm()) {
				this.isUpdatingDigitalTerm = false;
				return this.notificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			}

			this.cmdbHomeScreenService
				.updateCmdbDigitalTerm(termId, this.cmdbDigitalTermPayload)
				.subscribe({
					next: () => {
						this.infoUserModal.closeModal();
						this.isEditingTerm = false;
						this.isUserNotified = false;
						this.getDigitalTermLogs(this.selectedCi.id);
						this.notificationService.setNotificationMessage(this.labels.lbl_termo_digital_enviado_sucesso);
					},
					error: (errorRes) => {
						if (errorRes.error.ExtendedInfo && errorRes.error.ExtendedInfo != '') {
							const extendedInfo = this.labels[errorRes.error.ExtendedInfo]
								? this.labels[errorRes.error.ExtendedInfo]
								: errorRes.error.ExtendedInfo;
							this.notificationService.setNotificationMessage(extendedInfo);
						}
					},
				})
				.add(() => {
					this.isUpdatingDigitalTerm = false;
				});
		} else {
			this.cmdbHomeScreenService
				.createCmdbDigitalTerm(this.cmdbDigitalTermPayload)
				.subscribe({
					next: (response) => {
						if (response.status === 201) {
							this.infoUserModal.closeModal();
							this.isEditingTerm = false;
							this.isUserNotified = false;
							this.getDigitalTermLogs(this.selectedCi.id);
							this.notificationService.setNotificationMessage(this.labels.lbl_termo_digital_enviado_sucesso);
						} else if (response.status === 206) {
							this.isEditingTerm = true;
							this.isUserNotified = false;
							this.notificationService.setNotificationMessage(this.labels.lbl_termo_usuario_nao_associado);
						}
					},
					error: (errorRes) => {
						if (errorRes.error.ExtendedInfo && errorRes.error.ExtendedInfo != '') {
							const extendedInfo = this.labels[errorRes.error.ExtendedInfo]
								? this.labels[errorRes.error.ExtendedInfo]
								: errorRes.error.ExtendedInfo;
							this.notificationService.setNotificationMessage(extendedInfo);
						}
					},
				})
				.add(() => {
					this.isUpdatingDigitalTerm = false;
				});
		}
	}

	async getSendEmailCopy(): Promise<void> {
		this.isLoadingUserCopy = true;
		try {
			const users = await firstValueFrom(this.cmdbRegisterPageInfoService.getSendEmailCopy());
			this.allowedUserCopy = [];
			this.allowedUserCopyIAC = [];
			this.allowedUserCopy = users;
			for (const user of this.allowedUserCopy) {
				const usersIAC: iacOptionInterface = {
					name: user.name,
					secondName: user.email,
					value: user.value,
					commonGroup: user.email,
				};
				this.allowedUserCopyIAC.push(usersIAC);
			}
			this.isLoadingUserCopy = false;
		} catch {
			this.isLoadingUserCopy = false;
		}
	}
}
